import dataType from '../dataType';

const annaDsbUpiEnrichment = {
    name: 'AnnaDsbUpiEnrichment',
    type: dataType.string
};

export default annaDsbUpiEnrichment;
